module.exports = __webpack_public_path__ + "img/RJC_LP_rjc@2x.bc8e467.jpg";